import router from '@/router/app/router';
export default router;
